document.addEventListener("DOMContentLoaded", function () {

  /* ==============================
     Transparent Header
  ============================== */

  const siteHeader = document.querySelector(".header-wrapper");

  if (siteHeader) {

    siteHeader.classList.add("is-transparent");

    window.addEventListener("scroll", function () {

      if (window.scrollY > 80) {

        siteHeader.classList.add("is-scrolled");
        siteHeader.classList.remove("is-transparent");

      } else {

        siteHeader.classList.remove("is-scrolled");
        siteHeader.classList.add("is-transparent");

      }

    });


    const drawer = document.querySelector("#Details-menu-drawer-container");

    drawer?.addEventListener("toggle", function () {

      if (this.open) {

        siteHeader.classList.add("is-scrolled");
        siteHeader.classList.remove("is-transparent");

      } else if (window.scrollY < 80) {

        siteHeader.classList.remove("is-scrolled");
        siteHeader.classList.add("is-transparent");

      }

    });

  }

});



/* ==============================
   Shopify Forms Logo Injection
============================== */

function injectPopupLogo(shadow) {

  const popup = shadow.querySelector(
    "._overlay_1q1d2_100"
  );

  if (!popup) return;


  const formHeader = popup.querySelector(
    "section._formHeader_jnbzb_24"
  );

  if (!formHeader) return;


  if (!formHeader.querySelector("._popup-logo-wrapper")) {

    formHeader.insertAdjacentHTML(
      "afterbegin",
      `
      <div class="_popup-logo-wrapper">
        <img
          class="_popup-logo"
          src="https://cdn.shopify.com/s/files/1/0732/3998/6363/files/sunflower-953ad30b_86cb8652-7b53-45b4-926b-46d5b40c6a2e.svg?v=1784726647"
          alt="Sunflower"
        >
      </div>
      `
    );

  }

}



/* ==============================
   Shopify Forms Styles
============================== */

function injectShopifyFormsStyles() {

  document.querySelectorAll("shopify-forms-embed").forEach(embed => {

    if (!embed.shadowRoot) return;


    const shadow = embed.shadowRoot;


    /* ==============================
       Identify Inline Form
    ============================== */

    const formRoot = embed.closest('[data-form-root="true"]');

    const formId = formRoot ? formRoot.id : "";


    /* ==============================
       Forms With Light Input Styling
    ============================== */

    const lightInputFormIds = [
      "AMG1wK256MVNvb2Vpa__forms_inline_Eh6jWP",
      "AVW5HMmY2eFNGZlVme__forms_inline_HLNpqL",
      "AaHJ1QVNycytuaU9ST__forms_inline_x34wYj",
      "ANHJFZzR0U2w5cW82V__forms_inline_RBHnKz"
    ];


    /* ==============================
       Newsletter Heading On Footer
    ============================== */

    const footerNewsletter = [
      "AVW5HMmY2eFNGZlVme__forms_inline_HLNpqL"
    ];


    const isLightInputForm =
      lightInputFormIds.includes(formId);


    const isFooterNewsletter =
      footerNewsletter.includes(formId);



    /* ==============================
       Inject Popup Logo
    ============================== */

    injectPopupLogo(shadow);



    /* ==============================
       Prevent Duplicate Styles
    ============================== */

    if (shadow.querySelector("#custom-shopify-style")) return;



    const style = document.createElement("style");

    style.id = "custom-shopify-style";


    style.textContent = `

      /* ==============================
         Global Shopify Forms
      ============================== */

      * {
        font-family: "Quentin Regular", sans-serif !important;
      }


      input,
      textarea,
      select,
      button,
      label {
        font-family: "Quentin Regular", sans-serif !important;
        font-size: 14px;
      }
      

      input,
      textarea,
      select,
      button[type="button"] {

        background: transparent !important;
        border: solid 1.3px #000 !important;

      }


      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        background: transparent !important;
      }


      ._textHeading_2aowh_35 {

        font-size: var(--font-body-font-size) !important;
        margin-bottom: -10px !important;

      }


      ::placeholder {
        font-family: "Quentin Regular", sans-serif !important;
      }



      /* ==============================
         Popup Heading
      ============================== */

      ._overlay_1q1d2_100 h2._textHeading_2aowh_35 {

        margin: 20px !important;
        font-size: 3rem !important;
        line-height: 1.3em !important;

      }


      ._overlay_1q1d2_100 ._textBody_2aowh_10 p {

        font-family: "Copperplate", serif !important;

      }


      ._overlay_1q1d2_100
      ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {

        background-color: rgba(245,243,237,1) !important;

      }



      /* ==============================
         Popup Logo
      ============================== */

      ._popup-logo-wrapper {

        width: 100%;
        display: flex !important;
        justify-content: center;
        margin-bottom: 20px !important;

      }


      ._popup-logo {

        display: block !important;
        width: 110px !important;
        height: auto !important;

      }



      /* ==============================
         Popup Inputs
      ============================== */

      ._overlay_1q1d2_100 form input,
      ._overlay_1q1d2_100 form textarea,
      ._overlay_1q1d2_100 form select {

        background: rgba(245,243,237,1) !important;
        border: 1px solid #CBA45D !important;
        color: #000 !important;

      }


      ._overlay_1q1d2_100 input::placeholder,
      ._overlay_1q1d2_100 textarea::placeholder {

        color: #000 !important;

      }



      /* ==============================
         Popup Labels
      ============================== */

      ._overlay_1q1d2_100 label {

        color: #000 !important;

      }



      /* ==============================
         Popup Submit Button
      ============================== */

      ._overlay_1q1d2_100 form button[type="submit"] {

        background: #CBA45D !important;
        color: #fff !important;
        border: 1px solid #CBA45D !important;
        transition: all .3s ease !important;

      }


      ._overlay_1q1d2_100 form button[type="submit"]:hover {

        background: #fff !important;
        color: #CBA45D !important;
        border-color: #CBA45D !important;

      }



      /* ==============================
         Selected Inline Forms
         IDs Are Outside Shadow DOM
      ============================== */

      ${isLightInputForm ? `

        input,
        textarea,
        select {

          background: rgba(102,102,102,0.15) !important;
          color: rgba(245,243,237,1) !important;
          border: solid 1.3px rgba(245,243,237,1) !important;

        }


        label {

          color: rgba(245,243,237,.8) !important;

        }


        input::placeholder,
        textarea::placeholder,
        select::placeholder {

          color: rgba(245,243,237,1) !important;
          opacity: 1 !important;

        }

      ` : ""}



      /* ==============================
         Footer Newsletter
      ============================== */

      ${isFooterNewsletter ? `

        h2._textHeading_2aowh_35 {

          font-size: 20px !important;
          color: #CBA45D !important;

        }

      ` : ""}



      /* ==============================
         Mobile
      ============================== */

      @media screen and (max-width:768px) {

        .newsletter__wrapper .shopify-app-block {

          width: 100% !important;

        }


        ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          min-width: var(--min-form-width) !important;
          width: 350px !important;

        }


        ._overlay_1q1d2_100
        ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {

          padding: 30px 20px !important;

        }


        ._overlay_1q1d2_100 ._grid_1q1d2_148 {

          width: 90% !important;

        }
    
        input,
        textarea,
        select,
        button,
        label {
          font-size: 12px !important;
        }
        h2._textHeading_2aowh_35 {
          font-size: 17px !important;
        }
      

      }



      /* ==============================
         Small Mobile
      ============================== */

      @media screen and (max-width:490px) {

        ._noImage_1q1d2_161 {

          display: block;
          max-width: 95%;

        }
        ._inline_1q1d2_47 ._formContainer_1q1d2_30{
          width: 100% !important;
        }

      }

    `;


    shadow.appendChild(style);

  });

}



/* ==============================
   Watch Shopify Forms Loading
============================== */

const shopifyFormsInterval = setInterval(() => {

  injectShopifyFormsStyles();


  const embeds = document.querySelectorAll(
    "shopify-forms-embed"
  );


  if (
    embeds.length &&
    [...embeds].every(embed =>
      embed.shadowRoot?.querySelector("#custom-shopify-style") &&
      embed.shadowRoot?.querySelector("._popup-logo-wrapper")
    )
  ) {

    clearInterval(shopifyFormsInterval);

  }


}, 250);